export default __webpack_public_path__ + "static/media/estate.ed66d136.svg";